import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Logo = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      await navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <button 
      onClick={handleClick}
      className="flex items-center space-x-3 group"
    >
      <img 
        src="https://res.cloudinary.com/newaisystems/image/upload/f_auto,q_auto,w_40/v1746902475/logo_tab_bhgydm.png" 
        srcSet="https://res.cloudinary.com/newaisystems/image/upload/f_auto,q_auto,w_40/v1746902475/logo_tab_bhgydm.png 1x, https://res.cloudinary.com/newaisystems/image/upload/f_auto,q_auto,w_80/v1746902475/logo_tab_bhgydm.png 2x"
        alt="New AI Systems Logo" 
        className="w-10 h-10 object-contain group-hover:opacity-80 transition-opacity duration-300"
        loading="eager"
        decoding="sync"
      />
      <span className="font-mono font-bold text-xl tracking-wide text-text-light group-hover:text-electric-blue transition-colors duration-300">
        NEW AI SYSTEMS
      </span>
    </button>
  );
};

export default Logo;